export default __webpack_public_path__ + "static/media/InstaMR.5fdedc8d.png";